<template>
  <div class="qr-redirect-page">
    <div class="redirect-content">
      <PassingOnLogo class="brand-logo-svg mb-6" />
      <v-progress-circular v-if="loading" indeterminate color="primary" size="48"></v-progress-circular>
      <v-alert v-if="error" type="error" variant="tonal" class="mt-4" max-width="400">
        {{ error }}
        <template v-slot:append>
          <v-btn variant="text" size="small" @click="goHome">Go Home</v-btn>
        </template>
      </v-alert>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import apiService from '../services/api'
import PassingOnLogo from '../components/PassingOnLogo.vue'

const route = useRoute()
const router = useRouter()
const loading = ref(true)
const error = ref('')

const goHome = () => router.push('/')

onMounted(async () => {
  const token = route.params.token
  if (!token) {
    error.value = 'Invalid QR code link.'
    loading.value = false
    return
  }
  try {
    const response = await apiService.get(`/anon/qr/${token}`)
    if (response.success) {
      if (response.expired || !response.shareSlug) {
        // Past memorial date or 1 month after QR creation — go to public feed without QR mode
        router.replace(`/for/${response.shareSlug}`)
      } else {
        // Active QR — open public feed in QR contribution mode, token carried in URL
        router.replace(`/for/${response.shareSlug}?qrt=${token}`)
      }
    } else {
      error.value = response.msg || 'This QR code is no longer valid.'
      loading.value = false
    }
  } catch (err) {
    console.error('QR redirect error:', err)
    error.value = 'Unable to process this QR code. Please try again.'
    loading.value = false
  }
})
</script>

<style scoped>
.qr-redirect-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, var(--v-theme-background) 0%, var(--v-theme-surface) 100%);
}
.redirect-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
}
</style>
